/**
 * Typesafe way to remove all nulls from an array.
 *
 * Example:
 * const x: Array<number | null> = [1, null, 3, 4];
 * const result = removeNulls(x); // returns [1, 3, 4]
 * result[0] + 3 // returns 4, typechecks
 */
export default function removeNulls<T>(array: Array<T>): Array<Exclude<T, null | undefined>> {
  return array.filter((element): element is Exclude<T, null | undefined> => element != null);
}
